import {ONE_TRUST_ANALYTICS_COOKIE_GROUP_ID} from '@/consts/oneTrust/oneTrustCookieGroups';

import useOneTrustConsentAllowed from './useOneTrustConsentAllowed';

const useOneTrustAnalyticsConsentAllowed = () => useOneTrustConsentAllowed([ONE_TRUST_ANALYTICS_COOKIE_GROUP_ID]);

export default useOneTrustAnalyticsConsentAllowed;
